import { render, staticRenderFns } from "./ItemServico.vue?vue&type=template&id=e26ba4ec&"
import script from "./ItemServico.vue?vue&type=script&lang=js&"
export * from "./ItemServico.vue?vue&type=script&lang=js&"
import style0 from "./ItemServico.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports